import React, { useState, useEffect, useCallback } from 'react';
import { getRelatorioPeriodo, getPedido } from '../api';

const PAGE_SIZE = 20;

function toDateStr(d) { const y = d.getFullYear(); const m = String(d.getMonth() + 1).padStart(2, '0'); const day = String(d.getDate()).padStart(2, '0'); return `${y}-${m}-${day}`; }
function fmt(v) { const n = Number(v); if (isNaN(n)) return 'R$ 0,00'; return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); }
function fmtData(d) { const parts = String(d).slice(0, 10).split('-'); if (parts.length !== 3) return ''; return `${parts[2]}/${parts[1]}/${parts[0]}`; }
function hojeLocal() { const d = new Date(); return new Date(d.getFullYear(), d.getMonth(), d.getDate()); }

function agruparPorProduto(movs) {
  const m = {};
  for (const x of movs) {
    const k = x.produto_nome;
    if (!m[k]) m[k] = { nome: k, vendas: 0, receita: 0, custo: 0 };
    if (x.tipo === 'entrada') m[k].custo += +x.valor_total;
    else { m[k].vendas += +x.quantidade; m[k].receita += +x.valor_total; }
  }
  return Object.values(m).filter(p => p.vendas > 0);
}

function Paginacao({ total, page, onPage }) {
  const pages = Math.ceil(total / PAGE_SIZE);
  if (pages <= 1) return null;
  const items = [];
  for (let i = Math.max(1, page - 2); i <= Math.min(pages, page + 2); i++) items.push(i);
  if (items[0] > 1) { items.unshift(1); if (items[1] > 2) items.splice(1, 0, '...'); }
  if (items[items.length - 1] < pages) { if (items[items.length - 1] < pages - 1) items.push('...'); items.push(pages); }

  return (
    <div className="btn-g" style={{ justifyContent: 'center', marginTop: 12 }}>
      <button className="btn btn3 btn-sm" disabled={page <= 1} onClick={() => onPage(1)}>«</button>
      <button className="btn btn3 btn-sm" disabled={page <= 1} onClick={() => onPage(page - 1)}>‹</button>
      {items.map((p, i) =>
        typeof p === 'number' ? (
          <button key={i} className={`btn btn-sm ${page === p ? 'btn1' : 'btn3'}`} onClick={() => onPage(p)}>{p}</button>
        ) : (
          <span key={i} style={{ padding: '4px 2px', color: 'var(--c3)' }}>…</span>
        )
      )}
      <button className="btn btn3 btn-sm" disabled={page >= pages} onClick={() => onPage(page + 1)}>›</button>
      <button className="btn btn3 btn-sm" disabled={page >= pages} onClick={() => onPage(pages)}>»</button>
    </div>
  );
}

export default function RelatorioFinanceiro() {
  const hoje = hojeLocal();
  const mesPassado = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1);
  const [inicio, setInicio] = useState(toDateStr(mesPassado));
  const [fim, setFim] = useState(toDateStr(hoje));
  const [dados, setDados] = useState(null);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');
  const [subTab, setSubTab] = useState('pedidos');
  const [page, setPage] = useState({ pedidos: 1, estoque: 1, custos: 1 });
  const [pedidoModal, setPedidoModal] = useState(null);

  const carregar = useCallback(async () => {
    setLoading(true); setErro(''); setPage({ pedidos: 1, estoque: 1, custos: 1 });
    try { setDados(await getRelatorioPeriodo(inicio || undefined, fim || undefined)); }
    catch (err) { setErro(err.message); }
    setLoading(false);
  }, [inicio, fim]);

  useEffect(() => { carregar(); }, [carregar]);

  const movs = dados?.movimentacoes || [];
  const custos = dados?.custos || [];
  const pedidos = dados?.pedidos || [];
  const vendas = movs.filter(m => m.tipo === 'saida');
  const estoques = movs.filter(m => m.tipo === 'entrada');
  const margem = dados ? agruparPorProduto(movs) : [];

  const getPage = (key) => page[key] || 1;
  const setPg = (key, v) => setPage(prev => ({ ...prev, [key]: v }));

  const SUB = [
    { key: 'pedidos', label: 'Pedidos' },
    { key: 'estoque', label: 'Estoque' },
    { key: 'margem', label: 'Margem' },
    { key: 'custos', label: 'Custos' },
  ];

  return (
    <div>
      <form onSubmit={(e) => { e.preventDefault(); carregar(); }} className="mb2">
        <div className="rp-fl">
          <div className="inp-r" style={{ flex: 1, minWidth: 0 }}>
            <input className="inp" type="date" value={inicio} onChange={e => setInicio(e.target.value)} />
            <input className="inp" type="date" value={fim} onChange={e => setFim(e.target.value)} />
          </div>
          <button className="btn btn1 btn-sm" type="submit" disabled={loading}>{loading ? '...' : 'Filtrar'}</button>
        </div>
      </form>

      {erro && <div className="err">{erro}</div>}

      {dados && (
        <>
          <div className="kpi-gd">
            <div className="kpi kpi--g"><span>Receita</span><b>{fmt(dados.total_saidas)}</b></div>
            <div className="kpi kpi--y"><span>Insumos</span><b>{fmt(dados.total_entradas)}</b></div>
            <div className="kpi kpi--r"><span>Op.</span><b>{fmt(dados.total_custos)}</b></div>
            <div className={`kpi ${dados.lucro >= 0 ? 'kpi--g' : 'kpi--r'}`}><span>Lucro</span><b>{fmt(dados.lucro)}</b></div>
          </div>

          <div className="btn-g mb2">
            {SUB.map(s => (
              <button key={s.key} className={`btn btn-sm ${subTab === s.key ? 'btn1' : 'btn3'}`}
                onClick={() => setSubTab(s.key)}>{s.label}</button>
            ))}
          </div>

          {subTab === 'pedidos' && (
            <>
              {pedidos.length === 0 ? (
                <div className="mt"><span className="mt-ico">🛒</span>Nenhum pedido no período.</div>
              ) : (
                <>
                  <div className="lst">
                    {pedidos.slice((getPage('pedidos') - 1) * PAGE_SIZE, getPage('pedidos') * PAGE_SIZE).map(p => (
                      <div key={`p-${p.id}`} className="it" style={{ flexWrap: 'wrap', cursor: 'pointer' }}
                        onClick={async () => { try { const d = await getPedido(p.id); setPedidoModal(d); } catch {} }}>
                        <div className="it-main">
                          <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                            <span className="bd bd-g">Pedido #{p.id}</span>
                            <span style={{ fontSize: 11, color: 'var(--c4)' }}>{new Date(p.data).toLocaleDateString('pt-BR')}</span>
                          </div>
                          {p.cliente_nome && <div style={{ fontSize: 12, color: 'var(--c4)', marginTop: 2 }}>{p.cliente_nome}</div>}
                          <div style={{ fontSize: 12, color: 'var(--c4)', marginTop: 1 }}>{p.quantidade_itens} un. • {p.qtd_produtos} produto(s)</div>
                        </div>
                        <div style={{ textAlign: 'right', flexShrink: 0 }}>
                          <div style={{ fontWeight: 700, fontSize: 16, color: 'var(--g)' }}>{fmt(p.total)}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <Paginacao total={pedidos.length} page={getPage('pedidos')} onPage={(p) => setPg('pedidos', p)} />
                </>
              )}
            </>
          )}

          {subTab === 'estoque' && (
            <>
              {estoques.length === 0 ? (
                <div className="mt"><span className="mt-ico">📦</span>Nenhuma entrada no período.</div>
              ) : (
                <>
                  <div className="lst">
                    {estoques.slice((getPage('estoque') - 1) * PAGE_SIZE, getPage('estoque') * PAGE_SIZE).map(m => (
                      <div key={`m-${m.id}`} className="it">
                        <div className="it-main">
                          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <span className="bd bd-g">Estoque</span>
                            <span style={{ fontSize: 11, color: 'var(--c4)' }}>{new Date(m.data).toLocaleDateString('pt-BR')}</span>
                          </div>
                          <div style={{ marginTop: 3, fontSize: 13 }}><strong>{m.produto_nome}</strong></div>
                        </div>
                        <div style={{ textAlign: 'right', flexShrink: 0 }}>
                          <div style={{ fontWeight: 700, fontSize: 13 }}>{m.quantidade}x</div>
                          <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--y)' }}>{fmt(m.valor_total)}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <Paginacao total={estoques.length} page={getPage('estoque')} onPage={(p) => setPg('estoque', p)} />
                </>
              )}
            </>
          )}

          {subTab === 'margem' && (
            <>
              {margem.length === 0 ? (
                <div className="mt"><span className="mt-ico">📊</span>Nenhuma venda no período.</div>
              ) : (
                <div className="mg-cd">
                  {margem.map(p => {
                    const mg = p.receita - p.custo;
                    const mgUn = p.vendas > 0 ? mg / p.vendas : 0;
                    return (
                      <div key={p.nome} className="mg-i">
                        <div className="mg-t"><strong>{p.nome}</strong><span className="bd bd-g">{p.vendas} vendas</span></div>
                        <div className="mg-b">
                          <div><span>Receita</span> <strong>{fmt(p.receita)}</strong></div>
                          <div><span>Custo</span> <strong>{fmt(p.custo)}</strong></div>
                          <div><span>Margem</span> <strong style={{ color: mg >= 0 ? 'var(--g)' : 'var(--r)' }}>{fmt(mg)}</strong></div>
                          <div><span>/un</span> <strong>{fmt(mgUn)}</strong></div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </>
          )}

          {subTab === 'custos' && (
            <>
              {custos.length === 0 ? (
                <div className="mt"><span className="mt-ico">🧾</span>Nenhum custo no período.</div>
              ) : (
                <>
                  <div className="lst">
                    {custos.slice((getPage('custos') - 1) * PAGE_SIZE, getPage('custos') * PAGE_SIZE).map(c => (
                      <div key={`c-${c.id}`} className="it">
                        <div className="it-main">
                          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <span className="bd bd-r">{c.categoria}</span>
                            <span style={{ fontSize: 11, color: 'var(--c4)' }}>{fmtData(c.data)}</span>
                          </div>
                          <div style={{ marginTop: 2 }}><strong style={{ fontSize: 13 }}>{c.descricao}</strong></div>
                        </div>
                        <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--r)', flexShrink: 0 }}>{fmt(c.valor)}</div>
                      </div>
                    ))}
                  </div>
                  <Paginacao total={custos.length} page={getPage('custos')} onPage={(p) => setPg('custos', p)} />
                </>
              )}
            </>
          )}
        </>
      )}

      {pedidoModal && (
        <div className="ov" onClick={() => setPedidoModal(null)}>
          <div className="mo" onClick={e => e.stopPropagation()} style={{ padding: '24px 20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <h3 style={{ margin: 0 }}>Pedido #{pedidoModal.id}</h3>
              <button className="btn btn3 btn-sm" onClick={() => setPedidoModal(null)}>✕</button>
            </div>
            <div style={{ display: 'flex', gap: 16, marginBottom: 14, fontSize: 13, color: 'var(--c4)' }}>
              <span>{new Date(pedidoModal.data).toLocaleDateString('pt-BR')}</span>
              {pedidoModal.cliente_nome && <span>👤 {pedidoModal.cliente_nome}</span>}
              <span>{pedidoModal.quantidade_itens} un.</span>
            </div>
            <div className="lst">
              {(pedidoModal.itens || []).map((item, i) => (
                <div key={i} className="it">
                  <div className="it-main">
                    <strong style={{ fontSize: 13 }}>{item.produto_nome}</strong>
                    <div style={{ fontSize: 12, color: 'var(--c4)' }}>{item.quantidade}x R$ {Number(item.preco_unitario).toFixed(2)}</div>
                  </div>
                  <strong style={{ color: 'var(--g)' }}>{fmt(item.subtotal)}</strong>
                </div>
              ))}
            </div>
            <div style={{ marginTop: 14, padding: '10px 0 0', borderTop: '2px solid var(--g)', textAlign: 'right', fontSize: 18, fontWeight: 800, color: 'var(--g)' }}>
              Total: {fmt(pedidoModal.total)}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
